import { Button, Dialog, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ConfirmRemoveUserPopUp = ({
  open,
  handleClose,
  handleRemove,
  userName,
}: {
  open: boolean;
  handleClose: () => void;
  handleRemove: () => void;
  userName: string;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          width: "400px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          rowGap: "20px",
        },
      }}
    >
      <Typography variant="body14Regular">
        {`${t("pages.entity.groups.areYouSureToRemove")} ${userName} ${t("pages.entity.groups.fromGroup")}`}
      </Typography>
      <Button variant="primary-sm" onClick={handleRemove} fullWidth>
        {t("pages.events.eventDetails.submit")}
      </Button>
    </Dialog>
  );
};

export default ConfirmRemoveUserPopUp;
